import { useMutation } from '@tanstack/react-query';
import { TokenPair } from '../client/auth-store';
import { newIdempotencyKey } from '../client/idempotency';
/**
 * Sign in.
 *
 * The backend is "deliberately generic on failure — never reveal which field
 * was wrong", so the form shows one message for the pair rather than marking
 * the email as unknown. That is a real anti-enumeration property and the UI
 * must not undo it by being helpful.
 *
 * `persist` is what "Keep me signed in" chooses, applied before the pair is
 * stored so an unticked box never writes to disk at all.
 */
export function useSignIn(http, auth) {
    return useMutation({
        mutationFn: async ({ email, password, persist = true, }) => {
            auth.setPersistence(persist ? 'local' : 'session');
            const pair = await http.post('/auth/token', { email, password }, { schema: TokenPair, idempotencyKey: newIdempotencyKey() });
            auth.set(pair);
            return pair;
        },
    });
}
//# sourceMappingURL=hooks.js.map